import PropTypes from "prop-types";

import ActionPopOutOptionWithSubMenu from "@/view/ActionPopOutOptionWithSubMenu";

const propTypes = {
  actionName: PropTypes.string,
  activeSubMenu: PropTypes.string,
  eventProperties: PropTypes.object.isRequired,
  icon: PropTypes.node,
  popOutContents: PropTypes.node,
  setActiveSubMenu: PropTypes.func,
  disabled: PropTypes.bool,
  dataProps: PropTypes.object,
};

const HideMobileAction = ({
  actionName,
  activeSubMenu,
  disabled,
  eventProperties,
  icon,
  popOutContents,
  setActiveSubMenu,
  dataProps,
}) => {
  return (
    <ActionPopOutOptionWithSubMenu
      actionName={actionName}
      activeSubMenu={activeSubMenu}
      disabled={disabled}
      eventProperties={eventProperties}
      icon={icon}
      popOutContents={popOutContents}
      setActiveSubMenu={setActiveSubMenu}
      dataProps={dataProps}
    />
  );
};

HideMobileAction.propTypes = propTypes;

export default HideMobileAction;
